import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { TagLocationRoute } from '../../routing'

export class TagLocationPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <TagLocationRoute />
          </Fragment>
        )
    }
}
